import React from "react";

import { unregister } from "./registerServiceWorker";
import "purecss/build/grids-responsive-min.css";
import "moment/min/moment-with-locales";
import { Provider } from "react-redux";
import configureStore from "./store";
import { render } from "react-dom";
import "purecss/build/pure.css";
import "./sass/Common.scss";
import App from "./App";

import "moment/locale/fr";

import { LocalizationProvider } from "fluent-react/compat";
import { generateBundles } from "./languages/config";

const store = configureStore();

render(
  <Provider store={store}>
    <LocalizationProvider bundles={generateBundles(navigator.languages)}>
      <App />
    </LocalizationProvider>
  </Provider>,
  document.getElementById("root")
);
unregister();
